/**
 * MSW browser worker, loaded ONLY when mocks are enabled.
 *
 * Every import here is dynamic and inside the guard on purpose. A static
 * `import { setupWorker } from 'msw/browser'` would put MSW and the whole
 * fixture set into the production bundle even when mocks are off — the branch
 * is dead code, but the import is not. Keeping it dynamic means Rolldown
 * code-splits it out entirely, and it is why @repo/mocks and msw are
 * devDependencies rather than dependencies.
 *
 * Requires public/mockServiceWorker.js, generated by
 * `pnpm --filter @repo/web exec msw init public/` and committed.
 */
export function mocksEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_MOCKS === 'true';
}

export async function startMocks(): Promise<void> {
  if (!mocksEnabled()) return;

  const [{ setupWorker }, { handlers }] = await Promise.all([
    import('msw/browser'),
    import('@repo/mocks/handlers'),
  ]);

  await setupWorker(...handlers).start({
    // 'bypass' rather than 'warn': Vite's own dev-server traffic (HMR, the
    // module graph) is unhandled by design, and warning on it buries real misses.
    onUnhandledRequest: 'bypass',
    quiet: false,
  });
}
